module.exports = __webpack_public_path__ + "static/media/ehealth_bpbg_banner_desktop.ee7106b7.jpg";